/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:44:47
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare ଖୋଲନ୍ତୁ",
    name2: "ଏକ ସଂରକ୍ଷଣ କରନ୍ତୁ",
    name3: "Carlcare ସହିତ, ଆପଣ ଯେକୌଣସି ସମୟରେ ଆପଣଙ୍କର ଅର୍ଡର ଦେଖିପାରିବେ।",
    name4: "",
    name5: "ଡାହାଣକୁ ସ୍ଲାଇଡ୍ କରନ୍ତୁ",
    name6: "ଯାଞ୍ଚ ସମ୍ପୂର୍ଣ୍ଣ",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02150880282.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
        name40: "Exclusive for",
    name41: "Jakarta Pusat!",
    name42: "Reservation Now",
    name43: "What is Carlcare Home Service ?",
    name44: "1.Carlcare Home Service is available for TECNO, Infinix, and itel users.",
    name45: "2.Enjoy convenient and efficient repair services anywhere (at home, in the office, at a café, on campus, or outdoors), saving you time and effort.",
    name46: "Why do we recommend choosing Carlcare Home Service ?",
    name47: "Free Home Service Charges",
    name48: "No home service fees required.",
    name49: "*For out of warranty or accidental damage, pay for parts and labor.",
    name50: "Easy Booking",
    name51: "Easily book through Carlcare App, website, hotline, or WhatsApp.",
    name52: "Safe & Reliable",
    name53: "With strict safety measures, ensuring your device is in trusted hands.",
    name54: "Official Support",
    name55: "All repairs by Carlcare official engineers use only original spareparts.",
    name56: "Ways to Book Carlcare Home Service",
    name57: "1. Open the Carlcare App",
    name58: '2. Tap "Reservation"',
    name59: '3. Choose "Carlcare Home Service"',
    name60: "4. Select your current location",
    name61: "5. Fill in the required details to complete the reservation",
    name62: "1. Open the Carlcare Official Website:https://www.carlcare.com/id/",
    name63: '2. Tap "Perbaiki Telepon"',
    name64: '3. Choose "Carlcare Home Service"',
    name65: "4. Select your current location",
    name66: "5. Fill in the required details to complete the reservation",
    name67: "Call Carlcare hotline: 021 5088 0282 to book Carlcare Home Service.",
    name68: "Contact Carlcare WhatsApp Business Account:+62-812-9009-0559 to Carlcare Home Service.",
    name69: "1.Device needs repair.",
    name70: "2.Book Carlcare Home Service.",
    name71: "3.Engineer contacts you to confirm the appointment time.",
    name72: "4.Engineer arrives at the scheduled time.",
    name73: "5.Complete the repair and make the payment.",
    name74: "Statement:",
    name75: "1.Free Home Service applies to service fees only. ",
    name76: "①Under Warranty: Enjoy free home service and repairs;",
    name77: "②Out of Warranty:Only pay for labor and spareparts,no extra home service charges.",
    name78: "2.Carlcare Home Service is currently limited to the the Jakarta Pusat and will gradually expand to more regions in the future. Please Stay tuned!",
    name79: "3.The final explanation of the activity belongs to Carlcare.",
    name80: "Carlcare App",
    name81: "Carlcare Website",
    name82: "Carlcare Hotline",
    name83: "Carlcare WhatsApp",
    name84: "No door-to-door fee",
    name85: "Service Process:",
  },
  order: {
    name1: "ଉପକରଣ ମଡେଲ ବାଛନ୍ତୁ",
    name2: "ତ୍ରୁଟି ବର୍ଣ୍ଣନା:",
    name3: "ସେବା ଷ୍ଟୋର୍ ଚୟନ କରିବାକୁ ଟ୍ୟାପ୍ କରନ୍ତୁ",
    name4: "ସେବା ଷ୍ଟୋର୍:",
    name5: "ସଂରକ୍ଷଣ ସମୟ:",
    name6: "ଦୟାକରି ଆପଣଙ୍କର ଡିଭାଇସ୍ ର ସମସ୍ୟାକୁ ବିସ୍ତୃତ ଭାବରେ ବର୍ଣ୍ଣନା କରନ୍ତୁ!",
    name7: "ଆଗମନ ସମୟ ବାଛିବା ପାଇଁ ଟ୍ୟାପ୍ କରନ୍ତୁ",
    name8: "ଦୟାକରି ଆପଣଙ୍କର ସଠିକ୍ ଯୋଗାଯୋଗ ବିବରଣୀ ପ୍ରବେଶ କରନ୍ତୁ ଯାହା ଦ୍ଵାରା ଆମେ ଆପଣଙ୍କ ସହିତ ଯୋଗାଯୋଗ କରିପାରିବୁ",
    name9: "ଉପଲବ୍ଧ ଆରକ୍ଷିତ ସମୟ ଏଠାରେ ଦିଆଯାଇଛି",
    name10: "ଦୟାକରି ଆପଣଙ୍କର ଫୋନ୍ ନମ୍ବର ପ୍ରବେଶ କରନ୍ତୁ",
    name11: "ମୂଲ୍ୟ",
    name12: "ବ୍ୟକ୍ତିଗତ ସୁଚ଼ନା:",
    name13: "ଦୟାକରି ଆପଣଙ୍କର ନାମ ପ୍ରବେଶ କରନ୍ତୁ",
    name14: "ଦାଖଲ କରନ୍ତୁ |",
    name15: "ବନ୍ଦ କର |",
    name16: "ତୁମେ ଭଲ",
  },
  shops: {
    name1: "ଆପଣ ବାଛିଥିବା ବ୍ରାଣ୍ଡ ଉପରେ ଆଧାର କରି, ନିମ୍ନଲିଖିତ ଷ୍ଟୋର ଗୁଡ଼ିକ ଆପଣଙ୍କୁ ସେବା ପ୍ରଦାନ କରିପାରିବ!",
    name2: "ଅଧିକ ଖୁଚୁରା ଷ୍ଟୋର୍ ଖୁ୍ବ୍ ଶୀଘ୍ର ଆସୁଛି! ଆମ ସହିତ ରୁହନ୍ତୁ!",
  },
  price: {
    name1: "ବ୍ରାଣ୍ଡ",
    name2: "ମଡେଲ୍‍",
    name3: "ଆଇଟମ୍",
    name4: "ମୂଲ୍ୟ",
    name5: "ବନ୍ଧୁତ୍ୱପୂର୍ଣ୍ଣ ରିମାଇଣ୍ଡର:",
    name6: "ଏହି ମୂଲ୍ୟଗୁଡିକ କେବଳ ସନ୍ଦର୍ଭ ପାଇଁ, ଏବଂ ପ୍ରକୃତ ମୂଲ୍ୟ ଆପଣଙ୍କ ଡିଭାଇସ୍ ର ସ୍ଥିତି ଅନୁସାରେ ହେବ।",
    name7: "ଯଦି କୌଣସି ବିଶେଷ ପ୍ରତୀକ ନାହିଁ, ମୂଲ୍ୟ ୟୁନିଟ୍ ହେଉଛି ସ୍ଥାନୀୟ ମୁଦ୍ରା ୟୁନିଟ୍।",
    name8: "କ୍ଷମା କରିବେ! ବର୍ତ୍ତମାନର ଅଞ୍ଚଳରେ କୌଣସି ମୂଲ୍ୟ ସୂଚନା ଉପଲବ୍ଧ ନାହିଁ",
    name11:"ଶ୍ରମ ମୂଲ୍ୟ",
    name12:"ମୋଟ ମୂଲ୍ୟ",
    name13: "5. ଯଦି ଶ୍ରମ ମୂଲ୍ୟ ହେଉଛି \"/\", ଏହାର ଅର୍ଥ ଶ୍ରମ ମୂଲ୍ୟ ପାଇଁ ଷ୍ଟୋର୍‌ର ପରାମର୍ଶ ନିଆଯିବା ଆବଶ୍ୟକ ରହିଛି।",
    item_main_board: "ମୁଖ୍ୟବୋର୍ଡ",
    item_screen_frame: "ସ୍କ୍ରିନ୍ (ଫ୍ରେମ୍)",
    item_screen_screen_frame: "ସେକେଣ୍ଡାରୀ ସ୍କ୍ରିନ୍ (ଫ୍ରେମ୍)",
    item_touch_screen: "ଟଚ୍‌ ସ୍କ୍ରିନ୍",
    item_camera: "କ୍ୟାମେରା",
    item_fixed_focus_camera: "ସ୍ଥିରିକୃତ ଫୋକସ୍ କ୍ୟାମେରା",
    item_auto_focus_camera: "ସ୍ୱତଃ ଫୋକସ୍ କ୍ୟାମେରା",
    item_screen: "ସ୍କ୍ରିନ୍",
    item_secondary_screen: "ସେକେଣ୍ଡାରୀ ସ୍କ୍ରିନ୍",
    item_fingerprint_module: "ଫିଙ୍ଗରପ୍ରିଣ୍ଟ ମଡ୍ୟୁଲ",
    item_speaker: "ସ୍ପିକର",
    item_receiver: "ପ୍ରାପ୍ତକର୍ତ୍ତା",
    item_small_board: "ଛୋଟ ବୋର୍ଡ",
    item_battery_cover: "ବ୍ୟାଟେରୀ କଭର୍",
    item_battery: "ବ୍ୟାଟେରୀ",
    item_charger: "ଚାର୍ଜର",
    item_usb_cable: "USB କେବଲ୍",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "ଡାଟା ନାହିଁ",
    name2: "ସେବା ପ୍ରଦାନକାରୀ:",
    name3: "ସେବା ବ୍ରାଣ୍ଡ:",
    name4: "ଟେଲିଫୋନ୍:",
    name5: "କ୍ରମର ପରିମାଣ:",
    name6: "ସେବା ମୂଲ୍ୟାୟନ",
    name7: "ସେବା ପରିବେଶ:",
    name8: "ସେବା ମନୋଭାବ:",
    name9: "ସେବା ଦକ୍ଷତା:",
    name10: "ସେବା ଗୁଣ:",
    name11: "ଗ୍ରାହକ ମୂଲ୍ୟାଙ୍କନ",
    name12:"ରୁ",
    name13:"ବନ୍ଦ ହୋଇଯାଇଛି",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare ଖୋଲନ୍ତୁ",
    name1: "ଦୟାକରି ଆରକ୍ଷଣ ସୂଚନାର ସ୍କ୍ରିନସଟ୍ ନିଅନ୍ତୁ ଏବଂ ପ୍ରାଥମିକତା ସେବାକୁ ପ୍ରବେଶ କରିବାକୁ ଏହାକୁ ଏକ ରସିଦ ଭାବରେ ସାଇତି ରଖନ୍ତୁ।",
    name2: "ସଫଳତାର ସହିତ ଦାଖଲ |",
    name3: "1. ଡାଟା ଖାଲି କରନ୍ତୁ",
    name4: "ଦୟାକରି ଆପଣଙ୍କ ଫୋନରେ ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ବ୍ୟକ୍ତିଗତ ତଥ୍ୟକୁ ଆଗୁଆ ବ୍ୟାକଅପ୍ ନେଇ ରଖନ୍ତୁ।",
    name5: "2. ପାୱାର୍ ଅନ୍ ପାସୱାର୍ଡ ଅକ୍ଷମ କରନ୍ତୁ",
    name6: "ସର୍ଭିସ୍ ଷ୍ଟୋର୍‌କୁ ଯିବା ପୂର୍ବରୁ ଦୟାକରି:",
    name7: "ସେବା ଷ୍ଟୋର୍:",
    name8: "ସଂରକ୍ଷଣ ସମୟ:",
    name9: "ତ୍ରୁଟି ବର୍ଣ୍ଣନା:",
    name10: "ଡିଭାଇସ୍ ମଡେଲ:",
    name11: "ଅର୍ଡର ନମ୍ବର：",
    name12: "ଅର୍ଡର ସୂଚନା",
  },
  title: {
    
    name1: "ନିମ୍ନଲିଖିତ ଦେଶଗୁଡ଼ିକୁ ସମର୍ଥନ କରେ:",
    name2: "ମଡେଲ୍ ବାଛନ୍ତୁ",
    name3: "ସଂରକ୍ଷଣ",
    name4: "ସେବା ଷ୍ଟୋର୍ ବିବରଣୀ",
    name5: "ସେବା ଷ୍ଟୋର୍ ଚୟନ କରନ୍ତୁ",
  },
  error: {
    
    name1: "କୌଣସି ତଥ୍ୟ ନାହିଁ। ଦୟାକରି ଆପଣଙ୍କର ମରାମତି ସୂଚନା ଦେଖନ୍ତୁ",
    name2: "ଅଧିକ ସାହାଯ୍ୟ ଆବଶ୍ୟକ କରନ୍ତି କି? ଦୟାକରି ଆମ ସହିତ ଯୋଗାଯୋଗ କରନ୍ତୁ.",
    name3: "କ୍ଷମା କରିବେ, ବର୍ତ୍ତମାନର ଅଞ୍ଚଳରେ Carlcare କେନ୍ଦ୍ର ନାହିଁ।",
    name4: "ଦୟାକରି ପ୍ରଥମେ ଏକ ସେବା କେନ୍ଦ୍ର ଚୟନ କରନ୍ତୁ",
    name5: "ବିଫଳ",
    name6: "ଦୟାକରି ପ୍ରଥମେ ଡିଭାଇସ୍ ମଡେଲ୍ ଚୟନ କରନ୍ତୁ",
    name7: "ବିବରଣୀ",
    name8: "ଦୟାକରି ଆପଣଙ୍କର ଆବଶ୍ୟକତାକୁ ବିସ୍ତାର ପୂର୍ବକ ବର୍ଣ୍ଣନା କରନ୍ତୁ",
    name9: "",
  },
  add1:{
    "name0": "or",
    "name1": "ଆପଣଙ୍କ ଅର୍ଡ଼ର ସୁନିଶ୍ଚିତ କରାଯାଇଛି. ଆମେ ଆପଣଙ୍କ ଆଗମନକୁ ଅପେକ୍ଷା କରିଛୁ.",
    "name2": "ସହର ଚୟନ କରନ୍ତୁ",
    "name3": "ଦୟାକରି %1$s ଅଙ୍କର ଏକ ଫୋନ୍\u200c ନମ୍ୱର ଇନପୁଟ୍\u200c କରନ୍ତୁ.",
    "name4": "ସାପ୍ତାହିକ ଘଣ୍ଟା",
    "name5": "ସୋମବାର",
    "name6": "ମଙ୍ଗଳବାର",
    "name7": "ଆର୍ବାକୋ",
    "name8": "ଗୁରୁବାର",
    "name9": "ଶୁକ୍ରବାର",
    "name10": "ଶନିବାର",
    "name11": "ରବିବାର",
    "name12": "ଦେଶ ଏଣ୍ଟର୍\u200c କରନ୍ତୁ ଏବଂ ସନ୍ଧାନ କରନ୍ତୁ"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "ଅନ୍ୟାନ୍ୟ",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"ପୁନଃନିର୍ଦ୍ଦେଶ କରିବାକୁ ଟ୍ୟାପ୍‌ କରନ୍ତୁ",
    name3:"ଅର୍ଡରଟିର ମୂଲ୍ୟାୟନ କରିବାକୁ Carlcare ଆପ୍‌ ଖୋଲନ୍ତୁ",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"ସେବା ଚୟନ କରନ୍ତୁ",
    name7:"ମାଗଣା ସଫା କରିବା",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "ଭୁଲ୍‌ ସୂଚନା",
    "cancelReason1": "ଠିକ୍‌ ସମୟରେ ପହଞ୍ଚିପାରିବେ ନାହିଁ",
    "cancelReason2": "ନକଲ ଅର୍ଡର/ ମୋ ଅର୍ଡର ନୁହେଁ",
    "cancelReason3": "ପୁନର୍ବାର ବିଫଳତା ହୁଏ ନାହିଁ",
    "cancelReason4": "କେବଳ ପରୀକ୍ଷା/ ଅନୁସନ୍ଧାନ/ ଇଭେଣ୍ଟ୍‌/ ପାଇଁ …",
    "cancelReason5": "ଉଚ୍ଚ ଦାମ୍‌",
    "cancelReason6": "ସାମଗ୍ରୀର ଅଭାବ",
    "cancelReason7": "କୌଣସି ଭିନ୍ନ ସେବା ନାହିଁ",
    "cancelReason8": "ଦୋକାନ ବହୁତ ଦୂରରେ",
    "cancelReason9": "ଦୋକାନ ବନ୍ଦ ଅଛି",
    "cancelReason10": "ଖରାପ ସେବା ମନୋବୃତ୍ତି",
    "cancelReason11": "ଅନ୍ୟ ବ୍ରାଣ୍ଡଗୁଡିକ ପାଇଁ ପ୍ରତିସ୍ଥାପନ/ମରାମତି କରନ୍ତୁ",
    "cancelReason12": "ଷ୍ଟୋରକୁ ଖୋଜିପାରିବୁ ନାହିଁ",
    "cancelReason13": "ଅନ୍ୟମାନେ |",
    "cancelOrder": "ଅର୍ଡର ବାତିଲ୍ କରନ୍ତୁ",
    "reason_dialog_title": "ଦୟାକରି ବାତିଲର କାରଣ ଆମକୁ କୁହନ୍ତୁ",
    "Cancel": "ବନ୍ଦ କର |",
    "OK": "ତୁମେ ଭଲ",
    "name1": "Enter verification code",
    "name2": "ଅବୈଧ ଯାଞ୍ଚ କୋଡ୍",
    "repair_reservation_detail_canceled": "ଏହି ଆଦେଶ ବାତିଲ ହୋଇଛି!",
    "purchase_cancel_dialog_content": "ଅର୍ଡରଟି ବାତିଲ୍ କରିବାକୁ ଆପଣ ନିଶ୍ଚିତ କରନ୍ତି କି?",
    "yes": "ହଁ",
    "no": "ମାୟା"
}
};
